import { gql, MutationHookOptions, useMutation } from "@apollo/client";

export const DELETE_CREDENTIAL = gql`
  mutation deleteCredential {
    deleteCredential @client
  }
`;

export default (
  options?: MutationHookOptions<null, null>
) => {
  return useMutation<null, null>(
    DELETE_CREDENTIAL,
    options
  );
};
